<template>
  <p>Selecciona el elemento que deseas agregar</p>

  <div class="list__container">
    <TemplateItemAddCard
      v-for="item in itemsToAddList"
      :key="item.type"
      :item="item"
      :selected="item.type === selected?.type"
      :disabled="isDisabledByType(item.type)"
      @select="handleSelect"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

import { ItemType, TemplateItemOption } from "@/@types/flows/emailTemplates/items";
import { itemsToAddList } from "@/app/flows/emailTemplates/utils/items";

import TemplateItemAddCard from "@/app/flows/emailTemplates/components/cards/TemplateItemAddCard.vue";

const selected = ref<TemplateItemOption>();

const handleSelect = (item: TemplateItemOption) => {
  selected.value = item;
};

const isDisabledByType = (type: ItemType) => {
  return false;
};

defineExpose({ selected });
</script>

<style scoped lang="sass">
p
  color: $gray-8
  font-size: 12px

.list
  &__container
    display: grid
    grid-template-columns: 1fr 1fr
    gap: 16px 20px
</style>
